import React, { useEffect, useState } from 'react';
import { Pagination } from '../Pagination/Pagination';
export const PaginationWithoutQuery = ({ limit, resetPaginationOnChange, values, onChange, }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [cursors, setCursors] = useState({ start: 0, end: limit });
    const [paginatedValuesLength, setPaginatedValuesLength] = useState(0);
    // Passes back the updated paginated list when currentPage or master values is changed, also sets length of current paginated list to render correct controls
    useEffect(() => {
        const updatedPaginatedValues = values === null || values === void 0 ? void 0 : values.slice(cursors.start, cursors.end);
        setPaginatedValuesLength(updatedPaginatedValues === null || updatedPaginatedValues === void 0 ? void 0 : updatedPaginatedValues.length);
        onChange(updatedPaginatedValues);
    }, [cursors, currentPage, values]);
    // Resets pagination to page1 when resetPaginationOnChange is updated - intended to be used for filters/sorting on the master list
    useEffect(() => {
        if (!(resetPaginationOnChange === null || resetPaginationOnChange === void 0 ? void 0 : resetPaginationOnChange.length)) {
            return;
        }
        setCurrentPage(1);
        setCursors({ start: 0, end: limit });
    }, resetPaginationOnChange);
    return (React.createElement(Pagination, { currentPage: currentPage, limit: limit, pageInfo: {
            aggregateCount: values === null || values === void 0 ? void 0 : values.length,
            endCursor: cursors.end,
            hasNextPage: cursors.end < (values === null || values === void 0 ? void 0 : values.length),
            startCursor: cursors.start,
        }, quantity: paginatedValuesLength, getPage: (startCursor, endCursor) => {
            setCurrentPage(currentPage + endCursor);
            setCursors({
                start: startCursor + limit * (endCursor - 1),
                end: startCursor + limit * endCursor,
            });
        }, getNextPage: (cursor) => {
            setCurrentPage(currentPage + 1);
            setCursors({ start: cursor, end: cursor + limit });
        }, getPreviousPage: (cursor) => {
            setCurrentPage(currentPage - 1);
            setCursors({ start: cursor - limit, end: cursor });
        } }));
};
//# sourceMappingURL=PaginationWithoutQuery.js.map